import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Form, FormGroup } from 'reactstrap';
import { isRequired } from '../../../../utils/validators';
import FormItem from '../../../common/forms/FormItem';
import TextInput from '../../../common/forms/input/TextInput';
import FormFooter from '../../../common/forms/FormFooter';
import Loader from '../../../common/Loader';
import Select from '../../../common/forms/select/Select';
import { enumToSelectOptions } from '../../../../utils/enum';
import { GENERAL_INCOME_TYPE_LABEL } from '../../../../config/constants';


export const GeneralIncomeTypeForm = ({ handleSubmit, loading }) =>
  loading ? (
    <Loader />
  ) : (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="Nombre" required>
          <Field
            name="name"
            component={TextInput}
            type="text"
            placeholder="Nombre"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Código de Egreso" required>
          <Field
            name="expenseCode"
            component={TextInput}
            type="number"
            placeholder="Código de Egreso"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Clase de Tipo de Ingreso" required={[[isRequired]]}>
          <Field
            name="generalIncomeTypeLabelId"
            id="generalIncomeTypeLabelId"
            component={Select}
            options={enumToSelectOptions(GENERAL_INCOME_TYPE_LABEL)}
            showToolTip
            placeholder="Select"
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Descripción">
          <Field
            name="description"
            component={TextInput}
            type="textarea"
            placeholder="Descripción"
          />
        </FormItem>
      </FormGroup>
      <FormFooter />
    </Form>
  );

const mapStateToProps = ({ AccountingUnit }) => ({
  loading: !AccountingUnit.GeneralIncomeType.getIn(['current', 'activity']).isEmpty(),
});

GeneralIncomeTypeForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

GeneralIncomeTypeForm.defaultProps = {
  loading: false,
};

const formComponent = reduxForm({
  form: 'GeneralIncomeTypeForm',
})(GeneralIncomeTypeForm);

export default connect(mapStateToProps)(formComponent);
